"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _setImmediate2 = require("babel-runtime/core-js/set-immediate");

var _setImmediate3 = _interopRequireDefault(_setImmediate2);

exports.getReturnToUrl = getReturnToUrl;
exports.checkRedirectRequired = checkRedirectRequired;

var _index = require("./index");

var _sanitizeUrl = require("@braintree/sanitize-url");

var _reactRouter = require("react-router");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var whiteListURL = ["quixel.zendesk.com", "help.quixel.com", "zendesk.com", "quixel.com", "accounts.epicgames.com", "quixel.se", "epicgames-gamedev.ol.epicgames.net", "megascans.se"];
function setReturnToUrl(returnToUrl) {
  window.localStorage.setItem("returnToUrl", returnToUrl);
}
function clearReturnToUrl() {
  window.localStorage.removeItem("returnToUrl");
}

function getReturnToUrl() {
  var returnToUrl = (0, _sanitizeUrl.sanitizeUrl)(localStorage.getItem("returnToUrl"));
  clearReturnToUrl();
  return returnToUrl;
}

function checkRedirectRequired(urlToRedirect) {
  var sanitizeUrlReturnTo = (0, _sanitizeUrl.sanitizeUrl)(urlToRedirect);
  whiteListURL.push(window.location.hostname); //adding current host name explicitly for staging and dev enviorments.
  if ((0, _index.checkWhiteListURL)(whiteListURL, sanitizeUrlReturnTo)) {
    window.location = sanitizeUrlReturnTo;
  } else {
    setReturnToUrl(sanitizeUrlReturnTo);
    (0, _setImmediate3.default)(function () {
      _reactRouter.browserHistory.push("/");
    });
  }
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/RedirectToExternalSite.js
// module id = 274
// module chunks = 0